// extracted by mini-css-extract-plugin
export var menuIcon = "_on-0";
export var menuIconInline = "_on-1";